import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconTeam: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTeam"><Circle cx="12" cy="7.25" r="3" stroke="currentColor"/><Circle cx="5" cy="9.25" r="2" stroke="currentColor"/><Circle cx="19" cy="9.25" r="2" stroke="currentColor"/><Path d="M5.5 19.5H18.5C18.5 19.5 18.5 12 12 12C5.5 12 5.5 19.5 5.5 19.5Z" stroke="currentColor"/><Path d="M4 18.5H0.5C0.500156 17.5 1 13 6 13" stroke="currentColor"/><Path d="M20 18.5H23.5C23.4998 17.5 23 13 18 13" stroke="currentColor"/></CentralIconBase>;
});

export default IconTeam;
